module.exports = __webpack_public_path__ + "bundles/EventSubmission/assets/images/icons/location-22c9250626a38170f13a48147fbb5331.svg";


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/assets/images/icons/location.svg
// module id = 623
// module chunks = 0